import { Input, DatePicker, Select, Radio, Checkbox, InputNumber } from 'antd';
import {
  AntdInputStyles,
  AntdDatePickerStyles,
  AntdSelectStyles,
  AntdRadioStyles,
  AntdTextAreaStyles,
  AntdCheckboxStyles,
} from './indexStyles';

export const AntdInputNumber = ({
  label,
  bordered = false,
  labelWidth = 52,
  placeholder = '0.00',
  error,
  addonAfter = '元',
  max = 999999,
  min = 0,
  ...props
}) => {
  return (
    <AntdInputStyles
      labelWidth={labelWidth}
      disabled={props.disabled}
      hasError={Boolean(error)}
    >
      {label && (
        <label className="init-label" style={props.labelStyle}>
          {label}:
        </label>
      )}
      <InputNumber
        {...props}
        bordered={bordered}
        placeholder={placeholder}
        status={error ? 'error' : undefined}
        max={max}
        min={min}
        addonAfter={addonAfter}
      />
    </AntdInputStyles>
  );
};
export const AntdInput = ({
  label,
  bordered = false,
  labelWidth = 52,
  placeholder,
  error,
  thousandSeparator = false,
  ...props
}) => {
  const handleChange = (e) => {
    if (thousandSeparator) {
      const value = e.target.value.replace(/[^\d.]/g, '');
      if (value) {
        const parts = value.split('.');
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        e.target.value = parts.join('.');
      }
    }
    return props.onChange?.(e);
  };

  const handleBlur = (e) => {
    e.preventDefault();
    e.target.value = e.target.value?.trim();
    return props.onChange?.(e);
  };

  return (
    <AntdInputStyles
      labelWidth={labelWidth}
      disabled={props.disabled}
      hasError={Boolean(error)}
    >
      {label && (
        <label className="init-label" style={props.labelStyle}>
          {label}:
        </label>
      )}
      <Input
        {...props}
        bordered={bordered}
        placeholder={placeholder ?? '请输入'}
        allowClear
        status={error ? 'error' : undefined}
        showCount={Boolean(props.maxLength)}
        maxLength={props.maxLength}
        onChange={handleChange}
        onBlur={handleBlur}
      />
    </AntdInputStyles>
  );
};
export const AntdTextArea = ({
  label,
  bordered = false,
  labelWidth = 52,
  placeholder = '请输入',
  error,
  rows = 4,
  ...props
}) => {
  const handleBlur = (e) => {
    e.preventDefault();
    e.target.value = e.target.value?.trim();
    return props.onChange?.(e);
  };
  return (
    <AntdTextAreaStyles
      labelWidth={labelWidth}
      disabled={props.disabled}
      hasError={Boolean(error)}
    >
      {label && (
        <label className="init-label" style={props.labelStyle}>
          {label}:
        </label>
      )}
      <Input.TextArea
        {...props}
        rows={rows}
        bordered={bordered}
        placeholder={placeholder}
        allowClear
        status={error ? 'error' : undefined}
        showCount={Boolean(props.maxLength)}
        maxLength={props.maxLength}
        onBlur={handleBlur}
      />
    </AntdTextAreaStyles>
  );
};

export const AntdDatePicker = ({
  label,
  bordered = false,
  error,
  labelWidth = 52,
  format = 'YYYY/MM/DD',
  ...props
}) => {
  const { RangePicker } = DatePicker;
  return (
    <AntdDatePickerStyles
      labelWidth={labelWidth}
      disabled={props.disabled}
      hasError={Boolean(error)}
    >
      {label && (
        <label className="init-label" style={props.labelStyle}>
          {label}:
        </label>
      )}
      <RangePicker {...props} bordered={bordered} format={format} />
    </AntdDatePickerStyles>
  );
};

export const AntdSelect = ({
  label,
  bordered = false,
  labelWidth = 52,
  error,
  noborder = false,
  wrapStyle = true,
  ...props
}) => {
  return (
    <AntdSelectStyles
      labelWidth={labelWidth}
      noborder={noborder}
      wrapStyle={wrapStyle}
      disabled={props.disabled}
      hasError={Boolean(error)}
    >
      {label && (
        <label className="init-label" style={props.labelStyle}>
          {label}:
        </label>
      )}
      <Select {...props} bordered={bordered} allowClear showArrow />
    </AntdSelectStyles>
  );
};

export const AntdRadio = ({
  label,
  labelWidth = 52,
  noborder = false,
  wrapStyle = false,
  error,
  ...props
}) => {
  return (
    <AntdRadioStyles
      labelWidth={labelWidth}
      disabled={props.disabled}
      hasError={Boolean(error)}
      noborder={noborder}
      wrapStyle={wrapStyle}
    >
      {label && (
        <label className="init-label" style={props.labelStyle}>
          {label}:
        </label>
      )}
      <Radio.Group {...props} />
    </AntdRadioStyles>
  );
};

export const AntdCheckbox = ({
  label,
  labelWidth = 52,
  error,
  noborder = false,
  wrapStyle = true,
  ...props
}) => {
  return (
    <AntdCheckboxStyles
      labelWidth={labelWidth}
      disabled={props.disabled}
      hasError={Boolean(error)}
      noborder={noborder}
      wrapStyle={wrapStyle}
    >
      {label && <label className="init-label">{label}:</label>}
      <Checkbox.Group {...props} />
    </AntdCheckboxStyles>
  );
};
